import { Form, Switch, Table } from "antd";
import { createStyles } from "antd-style";

interface DataType {
  key?: string | number;
  holiday_name: string;
  holiday_date: string;
  status_toggle?: boolean;
}

export default function EditableTable() {
  const useStyle = createStyles(({ css }) => {
    return {
      customTable: css`
        .ant-table {
          .ant-table-container {
            .ant-table-body,
            .ant-table-content {
              scrollbar-width: thin;
              scrollbar-color: transparent transparent;
              scrollbar-gutter: stable;
              scrollbar-border-radius: 30px;
              transition: scrollbar-color 0.5s;

              &:hover {
                scrollbar-color: #dee5e6 transparent;
              }
            }
            .ant-table-thead {
              .ant-table-cell {
                height: 40px;
              }
            }
          }
        }
      `,
    };
  });

  const { styles } = useStyle();

  const columns = [
    {
      title: "Holiday name",
      dataIndex: "holiday_name",
      width: 466,
      editable: true,
    },
    {
      title: "Date",
      dataIndex: "holiday_date",
      width: 466,
      editable: true,
    },

    {
      title: "",
      width: 120,
      dataIndex: "status_toggle",
      render: () => {
        return <Switch defaultChecked />;
      },
    },
  ];

  return (
    <div className={styles.customTable}>
      <Form component={false}>
        <Table<DataType>
          components={{
            body: {},
          }}
          bordered
          columns={columns}
          rowClassName="editable-row"
        />
      </Form>
    </div>
  );
}
